import type { BasemapSource } from '../../../types/subscription';
import { BASEMAP_OPTIONS } from './packageForm';

/** A grid of map sources to tick; `tone` tells the online (cyan) and offline (green) lists apart. */
export function BasemapPicker({
  sources,
  value,
  onChange,
  tone,
  label,
}: {
  sources: BasemapSource[];
  value: BasemapSource[];
  onChange: (next: BasemapSource[]) => void;
  tone: 'cyan' | 'green';
  label: string;
}) {
  const on = tone === 'cyan' ? 'bg-cyan-500/10 border-cyan-500/50' : 'bg-green-500/10 border-green-500/50';
  const tick = tone === 'cyan' ? 'text-cyan-500 focus:ring-cyan-500' : 'text-green-500 focus:ring-green-500';
  return (
    <div role="group" aria-label={label} className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-2">
      {BASEMAP_OPTIONS.filter((b) => sources.includes(b.value)).map((basemap) => {
        const checked = value.includes(basemap.value);
        return (
          <label
            key={basemap.value}
            className={`flex items-start gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
              checked ? on : 'bg-slate-900/30 border-slate-700 hover:border-slate-600'
            }`}
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) =>
                onChange(e.target.checked ? [...value, basemap.value] : value.filter((b) => b !== basemap.value))
              }
              className={`w-4 h-4 mt-1 rounded bg-slate-700 border-slate-600 ${tick}`}
            />
            <span>
              <span className="block text-sm font-medium text-white">{basemap.label}</span>
              <span className="block text-sm text-slate-400">{basemap.description}</span>
            </span>
          </label>
        );
      })}
    </div>
  );
}
